/**
 * Constructs an object suitable to be set as history state such that it will be
 * compatible with useHistoryState. This can be used in advanced scenarios when
 * setting state for a page navigation that is intended to be read by another
 * component(s) that use useHistoryState with known state keys.
 *
 * Note that programmatically using `window.history.pushState` or
 * `window.history.replaceState` to update the state used by components using
 * useHistoryState that have already mounted is unsupported and will result in
 * undefined behavior. If you need to update history state that is used by a
 * component that has already mounted, you should key the component such that it
 * is forced to remount or lift the state up instead of using useHistoryState
 * directly.
 *
 * @param stateMap An object whose keys are state keys compatible with
 * useHistoryState, and whose values are the state values corresponding to those
 * keys.
 * @returns An object suitable to be set as history state.
 */
export const constructHistoryState = (stateMap: Readonly<Record<string, unknown>>) => stateMap;
